import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/bike/v1/contract';
import { DraftFactory } from '@qover/domain';
import { toDate } from '@qover/utils/src/date';
import { Draft } from '../Draft';

export function createFromApiResponse(response?: DraftProtos): Draft {
  const draft = DraftFactory.createFromApiResponse({
    ...response,
    calculatedField: response?.calculatedField,
    error: undefined,
    nextVersion: undefined,
    payment: response?.payment,
    policyholder: response?.policyholder,
    previousVersions: [],
    refs: response?.refs,
    risk: undefined,
    settings: response?.settings,
    terms: undefined,
    totalCoverage: response?.totalCoverage,
    versionInfo: response?.versionInfo,
  });

  return new Draft({
    ...draft,
    risk: {
      ...response?.risk,
      newBike: response?.risk?.newBike ?? true,
      bikePurchaseDate: toDate(
        response?.risk?.bikePurchaseDate ?? new Date(),
      ).toISOString(),
    },
    terms: response?.terms ?? {},
  });
}
